import { Component } from '@angular/core';
import { ListaProfissionaisComponent } from '../lista-profissionais/lista-profissionais.component';

@Component({
  selector: 'app-modal-anexar',
  templateUrl: './modal-anexar.component.html',
  styleUrls: ['./modal-anexar.component.scss']
})
export class ModalAnexarComponent {


  constructor ( public listaProfissionaisComponent: ListaProfissionaisComponent) {}

  
}
